"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _Microphone = require("./Microphone.styled");
var _ActionItemTooltip = _interopRequireDefault(require("../../ActionItemTooltip/ActionItemTooltip"));
var Microphone = function Microphone(_ref) {
  var onToggleMicrophone = _ref.onToggleMicrophone,
    knockId = _ref.knockId,
    isMicrophoneOn = _ref.isMicrophoneOn;
  return /*#__PURE__*/_react["default"].createElement(_Microphone.MicrophoneWrapper, null, /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "microphone-icon-".concat(knockId),
    message: "Set the initial state of the microphone when the user enters the studio",
    placement: "left",
    noPointerEvent: true
  }, /*#__PURE__*/_react["default"].createElement(_Microphone.MicrophoneContainer, {
    color: "light",
    variant: "outlined",
    onClick: onToggleMicrophone,
    "data-testid": "microphone-button",
    id: "microphone-icon-".concat(knockId)
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: isMicrophoneOn ? '#33373D' : '#DE2F1B',
    icon: isMicrophoneOn ? _freeSolidSvgIcons.faMicrophoneAlt : _freeSolidSvgIcons.faMicrophoneAltSlash
  }))));
};
Microphone.propTypes = {
  isMicrophoneOn: _propTypes["default"].bool,
  onToggleMicrophone: _propTypes["default"].func.isRequired,
  knockId: _propTypes["default"].string
};
var _default = exports["default"] = Microphone;